// src/features/PROVIDERS/page/Category

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import { Button, Tag } from 'antd'; //Space, Tag,
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { MedicalProviderType } from '../../types/providersTypes';
import Confirmation from "@/common/components/ConfirmButton";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { router } from '../../../../app/routing';
import { buildMedicalProviderAuditHistory } from '../../../../common/utils/auditUtils';



const MedicalProvider = () => {

    const providerActions = [
        {
            render: (record: MedicalProviderType) => {
                if (record.isActive) {
                    return (
                        <Confirmation
                            apiUrl={API_ENDPOINTS.PROVIDERS.INACTIVE_MEDICALPROVIDER}
                            method="post"
                            title="InActivate"
                            icon={<EyeInvisibleOutlined />}
                            id={record.id} // still needed for identification (and logging)
                            payloadKey="Id"
                            extraPayload={{
                                AuditHistory: buildMedicalProviderAuditHistory(record, "inactivate").map(a => ({
                                    ...a,
                                    actionType: "InActivate",
                                })),
                            }}
                            confirmButtonText="Are you sure you want to 'InActivate' this medical provider?"
                            queryKey={QUERY_KEYS.PROVIDERS.MEDICALPROVIDERS}
                            successMessage="Medical provider inactivated successfully"
                        />
                    );
                }
                return (
                    <Confirmation
                        apiUrl={API_ENDPOINTS.PROVIDERS.ACTIVE_MEDICALPROVIDER}
                        method="post"
                        title="Activate"
                        icon={<EyeOutlined />}
                        id={record.id}
                        payloadKey="Id"
                        extraPayload={{
                            AuditHistory: buildMedicalProviderAuditHistory(record, "activate").map(a => ({
                                ...a,
                                actionType: "Activate",
                            })),
                        }}
                        confirmButtonText="Are you sure you want to 'Activate' this medical provider?"
                        queryKey={QUERY_KEYS.PROVIDERS.MEDICALPROVIDERS}
                        successMessage="Medical provider activated successfully"
                    />
                );
            },
        },
    ];


    const medicalProviderColumns: ColumnsType<MedicalProviderType> = [
        //{ title: "Code", dataIndex: "code", key: "code" },
        {
            title: 'Code',
            key: 'code',
            render: (_, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        router.navigate({
                            to: '/providers/medical-provider/Detail', // Corrected path
                            state: { record: record } as Record<string, unknown>,
                        });
                    }}
                >
                    {record.code}
                </Button>
            ),
        },
        { title: "Name", dataIndex: "name", key: "name" },
        //{ title: "Name (Arabic)", dataIndex: "nameAr", key: "nameAr" },
        { title: "Email", dataIndex: "email", key: "email" },
        { title: "Telephone", dataIndex: "telephoneNo", key: "telephoneNo" },
        //{ title: "Address", dataIndex: "address", key: "address" },
        //{ title: "Address (Arabic)", dataIndex: "addressAr", key: "addressAr" },
        { title: "Country", dataIndex: "country", key: "country" },
        /* { title: "Country (Arabic)", dataIndex: "countryAr", key: "countryAr" },*/
        //{ title: "City", dataIndex: "city", key: "city" },
        //{ title: "State", dataIndex: "state", key: "state" },
        //{
        //    title: "In Network",
        //    dataIndex: "isInNetwork",
        //    key: "isInNetwork",
        //    render: (value: boolean) => (
        //        <Tag color={value ? "green" : "red"}>{value ? "Yes" : "No"}</Tag>
        //    ),
        //},
        {
            title: "Active",
            dataIndex: "isActive",
            key: "isActive",
            render: (value: boolean) => (
                <Tag color={value ? "green" : "red"}>{value ? "Yes" : "No"}</Tag>
            ),
        },
    ];

    return (
        <div>
            <DynamicTable<MedicalProviderType>
                dataApiUrl={API_ENDPOINTS.PROVIDERS.SEARCH_MEDICALPROVIDER}
                baseQueryKey={QUERY_KEYS.PROVIDERS.MEDICALPROVIDERS}
                columns={medicalProviderColumns}
                tableTitle={"Medical Providers"}
                secondButtonTitle="Save Pricing"
                secondButtonUrl="/providers/medical-provider/bulkForm" // <-- your redirect URL
                secondButtonPermissionKey={API_ENDPOINTS.PROVIDERS.SAVE_BULK_MEDICALPROVIDER_SERVICE_ITEM_PRICING}
                actionColumnWidth={200}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.PROVIDERS.DELETE_MEDICALPROVIDER}
                deletePayloadField="code"

                customActions={providerActions}
                filterConfigs={[
                    { field: "name", placeholder: "Search by provider name" },
                    { field: "code", placeholder: "Search by code" },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.PROVIDERS.EXPORT_MEDICALPROVIDER,
                            fileName: "MedicalProviders",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Code", key: "code" },
                                { header: "Name", key: "name" },
                                { header: "Email", key: "email" },
                                { header: "Telephone", key: "telephoneNo" },
                                { header: "Country", key: "country" },
                                { header: "Active", key: "isActive", transform: (val: boolean) => val === true ? "Yes" : "No" },
                            ]
                        }
                    }
                    //{ field: "email", placeholder: "Search by email" }
                ]}
            />
        </div>
    );
};

export default MedicalProvider;
